import { usePitcher } from "features/utils/usePitcher";

import { executeVSCodeCommand } from "utils/vscode";

import type { Command } from "../../types";

export const useCreateTasksConfigCommand = (): Command => {
  const pitcher = usePitcher();

  return {
    name: `Create Tasks Configuration`,
    id: "codesandbox.tasks.openOrCreateConfig",
    section: "CodeSandbox Tasks",
    perform: () => {
      pitcher.clients.task.generateConfigFile().then((fileId) => {
        const relativePath = pitcher.clients.fs.getPathFromId(fileId);
        if (relativePath) {
          executeVSCodeCommand("workbench.explorer.fileView.focus");

          executeVSCodeCommand("codesandbox.openCsbTab", {
            type: "FILE",
            filepath: relativePath,
          });
        }
      });
    },
  };
};
